import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialState from './state';

const slice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setIsOnline: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
  },
});

export const { setIsOnline } = slice.actions;

export default slice.reducer;
